import React from 'react'
import { Link } from 'react-router-dom'
import { useDiscoveredYears } from '../../utils/useDiscoveredYears'
import { conferenceMeta } from '../../data/conferenceMeta'

export const Homepage = () => {
	const { years } = useDiscoveredYears();

	return (
		<>
			{years.map((year) => {
				const meta = conferenceMeta[year];
				return (
					<p key={year}>
						<b><Link to={`/irim3d/${year}`}>{year} I-RIM Conference</Link></b>
						<br />
						{meta && meta.bodyLines.map((line, i) => (
							<React.Fragment key={i}>{line}<br /></React.Fragment>
						))}
						{meta && meta.website && (
							<a href={meta.website}>Conference web site</a>
						)}
					</p>
				);
			})}
		</>
	)
}
